import { useContext } from "react"
import { fetchResource } from "../../../methods/fetchResource"
import { UserContext } from "../../userContext"
import { ToggleSpinner } from "../../components/spinner"
import { generateErrorMessage } from "../../../methods/generateErrorMessage"

export default function ForgotPINButton({setMessage, setMessageIsError, buttonsHidden, setButtonsHidden}) {
    const userContext = useContext(UserContext)

    async function forgotPIN() {
        hideButtons()

        let pinMessage = await fetchResource(`/api/forgotPIN?parcelID=${userContext.parcelID}`)

        if(!pinMessage.success) {
            setMessageAndShowButtons(generateErrorMessage(pinMessage.status))
            return
        }

        setMessageIsError(false)
        
        setMessageAndShowButtons("An e-mail has been sent to the e-mail address registered with this parcel. If you do not remember the e-mail you used for this parcel, please contact us at (850) 983-1880")
    }

    function hideButtons() {
		setButtonsHidden(true)
        ToggleSpinner("spinner")
    }

    function setMessageAndShowButtons(message) {
        setMessage(message)
		setButtonsHidden(false)
        ToggleSpinner("spinner")
    }

    return (
        <button
            type="button"
            id="forgotPINButton"
            className={`btn btn-light ${buttonsHidden ? "d-none" : ""}`}
			disabled={buttonsHidden}
            onClick={forgotPIN}
        >
            <i className="fa-solid fa-circle-question"></i> I forgot my PIN
        </button>
    )
}